export default __webpack_public_path__ + "static/media/yarden_truck_left_side.a0c663f3.jpg";